import { useCallback } from "react";

import { useRouter } from "next/navigation";

import { useStore } from "@/store";
import { docPageUrl } from "@/urls";
import { trackEvent } from "@/utils/trackEvent";

import type { Folder } from "@/api";
import type { EventMap } from "@/utils/trackEvent";

export function useCreateInTree(source: EventMap["document_creation_clicked"]["source"]) {
  const router = useRouter();
  const { documentTree } = useStore();

  const createDocumentInTree = useCallback(
    async (folder?: Folder, position?: number) => {
      const doc = await documentTree.createDocumentOrFolder("document", folder, position);
      if (doc) {
        trackEvent("document_creation_clicked", { source });
        router.push(docPageUrl({ docId: doc.uid }));
      }
      return doc;
    },
    [documentTree, router, source],
  );

  const createFolderInTree = useCallback(
    async (folder?: Folder, position?: number) => {
      const newFolder = await documentTree.createDocumentOrFolder("folder", folder, position);
      if (newFolder) {
        trackEvent("folder_creation_clicked", { source });
      }
      return newFolder;
    },
    [documentTree, source],
  );

  return { createDocumentInTree, createFolderInTree };
}
